<template>
  <router-view />
</template>

<script>
export default {
  name: 'HotelsCancellationsIndex'
}
</script>
